import React from 'react';
import {Label} from 'react-bootstrap';

export default props => {
  const {value} = props;
  return (
    <Label bsStyle={value ? 'success' : 'warning'}>
      {value ? 'Yes' : 'No'}
    </Label>
  );
};



// WEBPACK FOOTER //
// ./src/components/BooleanDisplay.jsx